import { useMemo } from 'react';
import { AGREEMENT_STATE_ACCEPTED } from '../constants';
import type { Agreement } from '../types';

function isActiveAgreement(agreement: Agreement): boolean {
  if (agreement.deletedAt && agreement.deletedAt.trim() !== '') return false;
  if (agreement.state !== AGREEMENT_STATE_ACCEPTED) return false;
  if (
    agreement.validUntil &&
    agreement.validUntil.trim() !== '' &&
    new Date(agreement.validUntil) < new Date()
  ) {
    return false;
  }
  return true;
}

export function useActiveAgreements(agreements: Agreement[]): Agreement[] {
  return useMemo(() => agreements.filter(isActiveAgreement), [agreements]);
}
